
import "../css/styles.css";

import { useEffect, useRef, useState } from "react";

import Message from "./Message";

import { usePrompt } from "../context/PromptContext";
import { useMessage, useMessageUpdate } from "../context/MessageContext";
import { useSpeechSynthesisUpdate } from "../context/SpeechSynthesisContext";
//import { useInstruction, useInstructionUpdate } from "../context/ContentDeliveryContext";

import { useSession, useSessionUpdate } from "../context/SessionContext";


import { INSTRUCTOR_NAME, SERVER_ORIGIN, CHAT_SPINNER_DISPLAY_MODE, CHAT_SPINNER_OPACITY_LEVEL, SpinnerDisplayMode } from "../common/constants";
import AtomSpinner from "../common/AtomSpinner";

import { fetchLecturePage } from "../services/fetch";



export default function LectureContainer( ) {

  const [ isAtLectureStart, setIsLectureStart ] = useState<boolean>( true );
  const [ isPaused, setIsPaused ] = useState<boolean>( true ); // TODO: Reference useSession's State instead? -- May want to know it's paused across entire App, not just this Component (same for PresentationContainer.tsx)

  const [ pageNumber, setPageNumber ] = useState<number>( 1 );

  const { chatMessagePending } = useSession();
  const { getDefaultAppStateHandlerConfig } = useSessionUpdate();

  const { lectureMessages } = useMessage();
  const { streamAssistantResponse, processLecturePage } = useMessageUpdate();

  const { pauseSpeechSynthesis, resumeSpeechSynthesis } = useSpeechSynthesisUpdate();


  const messagesEndRef = useRef<HTMLDivElement>( null );


  useEffect( () => {
    if( messagesEndRef.current ) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [lectureMessages]);



  // TODO: startLecture,handleContinueLecture,togglePause are DUPLICATED(ish) here & in PresentationContainer
  // ... CONSIDER generalizing to a "ContentDeliveryContext" and organizing better
  const startLecture = async () => {
    const pageContent = await fetchLecturePage( pageNumber, getDefaultAppStateHandlerConfig() );
    setPageNumber( previous => previous + 1 );

    await processLecturePage( pageContent );

    /*
    const prompt = "Resume the lecture in whatever way is appropriate.";

    const assistantResponseOptions = { context: "", prompt: prompt, promptType: "generalPrompt", messageType: "LECTURE" };
    await streamAssistantResponse( assistantResponseOptions );
    */

    setIsLectureStart( false );
    setIsPaused( false );
  };

  const handleContinueLecture = async () => {
    const pageContent = await fetchLecturePage( pageNumber, getDefaultAppStateHandlerConfig() );

    setPageNumber( previous => previous + 1 );

    await processLecturePage( pageContent );

    /*
    const prompt = "Continue the lecture.";

    const assistantResponseOptions = { context: "", prompt: prompt, promptType: "generalPrompt", messageType: "LECTURE" };
    await streamAssistantResponse( assistantResponseOptions );
    */
  };

  const togglePause = () => {

    if( isPaused ) { // Intending to "Play"
      resumeSpeechSynthesis();
    }
    else { // Intending to "Pause"
      pauseSpeechSynthesis();
    }

    setIsPaused( !isPaused );
  }


  return (
    <div className="lecture-container">
        
        {/* Chat spinner when display mode is PRESENTATION_OVERLAY */}
        { chatMessagePending && (CHAT_SPINNER_DISPLAY_MODE as SpinnerDisplayMode) === SpinnerDisplayMode.PRESENTATION_OVERLAY && 
          <AtomSpinner displayMode={CHAT_SPINNER_DISPLAY_MODE} opacityLevel={CHAT_SPINNER_OPACITY_LEVEL} overlayMessage="Loading Lecture" /> }
        
        <div className="lecture-header" >
            Class Lecture
        </div>

        <div id="lecture-messages" className="lecture-messages">
            {lectureMessages.map( (message: IMessage) => {
              return <LectureMessage message={message} key={message.id} />
            })}
            <div ref={messagesEndRef} />
        </div>

        {/*
        <NavigationComponent />
        */}
        <div className="navigation-container">
          <button id="presentation-control-button" className="navigation-button presentation-control-button" type="button" onClick={ () => isAtLectureStart ? startLecture() : togglePause() }>{isPaused ? (isAtLectureStart ? "Start" : "Play") : "Pause"}</button>
          <button className="navigation-button" type="button" onClick={ () => handleContinueLecture() }>Next</button>
        </div>
    </div>
  );
}

/* TODO: Considering a different design where there's a "ContentDeliveryContext" that encompasses both Text-Based Lecture and Presentation-Based Lecture
function NavigationComponent() {

  const { isAtContentStart, startContent, togglePause } = useInstruction();
  const { continueContent } = useInstructionUpdate();

  return (
    <div className="navigation-container">
      <button id="presentation-control-button" className="navigation-button presentation-control-button" type="button" onClick={ () => isAtContentStart ? startContent() : togglePause() }>{isPaused ? (isAtContentStart ? "Start" : "Play") : "Pause"}</button>
      <button className="navigation-button" type="button" onClick={ () => continueContent() }>Next</button>
    </div>
  );
}
*/


interface LectureMessageProps {
  message: IMessage,
}
function LectureMessage( { message }: LectureMessageProps ) {

  return (
    <Message message={message} />
  );
}




